import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingProducts: false,
  loadingProduct: false,
  loadingProductCreate: false,
  loadingProductUpdate: false,
  loadingProductDelete: false,

  errorLoadingProducts: null,
  errorLoadingProduct: null,
  errorCreatingProduct: null,
  errorUpdatingProduct: null,
  errorDeletingProduct: null,

  products: [],
  product: null,

  serverStatus: null,
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setLoadingProducts(state) {
      state.loadingProducts = true;
      state.errorLoadingProducts = null;
    },
    setLoadingProduct(state) {
      state.loadingProduct = true;
      state.errorLoadingProduct = null;
    },
    setLoadingProductCreate(state) {
      state.loadingProductCreate = true;
      state.errorCreatingProduct = null;
    },
    setLoadingProductUpdate(state) {
      state.loadingProductUpdate = true;
      state.errorUpdatingProduct = null;
    },
    setLoadingProductDelete(state) {
      state.loadingProductDelete = true;
      state.errorDeletingProduct = null;
    },

    setErrorLoadingProducts(state, { payload }) {
      state.loadingProducts = false;
      state.errorLoadingProducts = payload;
    },
    setErrorLoadingProduct(state, { payload }) {
      state.loadingProduct = false;
      state.errorLoadingProduct = payload;
    },
    setErrorCreatingProduct(state, { payload }) {
      state.loadingProductCreate = false;
      state.errorCreatingProduct = payload;
    },
    setErrorUpdatingProduct(state, { payload }) {
      state.loadingProductUpdate = false;
      state.errorUpdatingProduct = payload;
    },
    setErrorDeletingProduct(state, { payload }) {
      state.loadingProductDelete = false;
      state.errorDeletingProduct = payload;
    },

    setProducts(state, { payload }) {
      state.loadingProducts = false;
      state.errorLoadingProducts = null;
      state.products = payload;
    },

    setProduct(state, { payload }) {
      state.loadingProduct = false;
      state.errorLoadingProduct = null;
      state.product = payload;
    },

    createProductSuccess(state, { payload }) {
      state.products = [payload, ...state.products];
      state.loadingProductCreate = false;
      state.errorCreatingProduct = null;
    },

    updateProductSuccess(state, { payload }) {
      state.products = state.products.map((u) =>
        u.id === payload.id ? payload : u,
      );

      if (state.product && state.product.id === payload.id) {
        state.product = payload;
      }

      state.loadingProductUpdate = false;
      state.errorUpdatingProduct = null;
    },

    deleteProductSuccess(state, { payload: idToDelete }) {
      state.products = state.products.filter((u) => u.id !== idToDelete);

      if (state.product && state.product.id === idToDelete) {
        state.product = null;
      }

      state.loadingProductDelete = false;
      state.errorDeletingProduct = null;
    },

    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingProducts,
  setLoadingProduct,
  setLoadingProductInfo,
  setLoadingProductCreate,
  setLoadingProductUpdate,
  setLoadingProductDelete,

  setErrorLoadingProducts,
  setErrorLoadingProduct,
  setErrorLoadingProductInfo,
  setErrorCreatingProduct,
  setErrorUpdatingProduct,
  setErrorDeletingProduct,

  setProducts,
  setProduct,
  createProductSuccess,
  updateProductSuccess,
  deleteProductSuccess,

  setServerResponseStatus,
} = productSlice.actions;

export default productSlice.reducer;

export const selectProduct = (state) => state.product;
